<template>
  <SoDialog
    ref="dialog"
    v-model="value"
    card-title="Add a note"
    :loading="addNoteMutator.isPending"
    @on-close="handleOnClose()"
  >
    <div v-if="addNoteMutator.isSuccess || addNoteMutator.isError">
      <div v-if="addNoteMutator.isSuccess">
        <SoAlert
          ref="success-alert"
          type="success"
          title="Note added"
          data-testid="add-note-success"
        />
      </div>
      <div v-if="addNoteMutator.isError">
        <SoAlert
          ref="failure-alert"
          type="error"
          title="Failed to add a note"
        />
      </div>
      <div class="d-flex mt-4">
        <v-spacer />
        <SoButton ref="close-btn" title="Close" large @click="value = false" />
      </div>
    </div>
    <SoForm v-else ref="form" @submit="addNote()">
      <SoTextField
        v-model="noteSummary"
        label="Summary"
        :rules="[rules.required]"
        data-testid="summary-text-field"
      />
      <SoTextarea
        v-model="noteContent"
        label="Contents"
        data-testid="content-text-field"
      />
      <div class="d-flex mt-4">
        <v-spacer />
        <SoButton title="Add" large submit data-testid="add-note-btn" />
      </div>
    </SoForm>
  </SoDialog>
</template>

<script lang="ts">
  import SoDialog from "@/components/SoDialog.vue"
  import SoTextField from "@/components/formControls/SoTextField.vue"
  import SoTextarea from "@/components/formControls/SoTextarea.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoForm from "@/components/formControls/SoForm.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import rules from "@/validators/rules"

  export default defineComponent({
    components: {
      SoDialog,
      SoTextField,
      SoTextarea,
      SoButton,
      SoForm,
      SoAlert,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
      accountNumber: {
        type: String,
        default: null,
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        addNoteMutator: useCurrentAccountStore().addNote(),
        noteSummary: "",
        noteContent: "",
        rules,
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
    methods: {
      addNote() {
        this.addNoteMutator.mutate({
          subject: "General Note",
          content: this.noteContent,
          summary: this.noteSummary,
        })
      },
      handleOnClose() {
        this.noteSummary = ""
        this.noteContent = ""
        this.addNoteMutator.reset()
        const form = this.$refs.form as InstanceType<typeof SoForm> | undefined
        form?.resetValidation()
      },
    },
  })
</script>
